import React from 'react';
import { withRouter } from 'react-router';
import { ExperimentName } from '@letsdothis/experiments';

import useExperiment from '@hooks/useExperiment';
import OldLoginComponent from '@/components/Login';
import { getRelativeUrl } from '@/utils/routing';

import { LoginContainerParams } from './Types';
import Login from './component';

const defaultRenderFooterProp = () => null;

const LoginContainer = (props: LoginContainerParams): JSX.Element => {
  const withStrava = props.location?.query?.with === 'strava';

  const queryReturnUrl = props.location?.query?.returnUrl;
  const returnUrl =
    props.customReturnUrl ||
    queryReturnUrl ||
    (props.location?.pathname !== '/login' && getRelativeUrl(props.location)) ||
    '/';

  const optionsOnly = props?.optionsOnly ?? false;
  const renderFooter = props?.renderFooter ?? defaultRenderFooterProp;
  const noBackground = props?.noBackground ?? false;

  const loginExperiment = useExperiment(ExperimentName.LDT_LOGIN);
  if (withStrava) {
    return <OldLoginComponent {...props} />;
  }
  return (
    <>
      {!loginExperiment && <OldLoginComponent {...props} />}
      {loginExperiment && (
        <Login
          {...props}
          returnUrl={returnUrl}
          renderFooter={renderFooter}
          optionsOnly={optionsOnly}
          noBackground={noBackground}
        />
      )}
    </>
  );
};

export default withRouter(LoginContainer);
